function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBetathreadTeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "500px",
    height: "500px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#24828d",
    d: "M -0.5,-0.5 C 166.167,-0.5 332.833,-0.5 499.5,-0.5C 499.5,166.167 499.5,332.833 499.5,499.5C 332.833,499.5 166.167,499.5 -0.5,499.5C -0.5,332.833 -0.5,166.167 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f8e5",
    d: "M 236.5,94.5 C 242.5,93.1667 244.833,95.5 243.5,101.5C 239.865,102.114 236.198,102.448 232.5,102.5C 233.255,110.204 234.255,117.87 235.5,125.5C 231.087,125.687 226.754,126.354 222.5,127.5C 221.998,120.151 221.331,112.817 220.5,105.5C 216.131,105.467 211.798,105.8 207.5,106.5C 207.5,104.167 207.5,101.833 207.5,99.5C 217.342,98.0977 227.009,96.4311 236.5,94.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f9e7",
    d: "M 251.5,93.5 C 255.832,94.2664 260.166,95.0997 264.5,96C 263.754,99.2804 263.087,102.614 262.5,106C 262.833,106.5 263.167,107 263.5,107.5C 268.415,108.726 273.415,109.393 278.5,109.5C 279.021,105.519 279.354,101.519 279.5,97.5C 283.832,98.2664 288.166,99.0997 292.5,100C 290.565,109.379 289.232,118.879 288.5,128.5C 284.466,128.495 280.466,128.162 276.5,127.5C 276.395,123.452 276.728,119.452 277.5,115.5C 272.207,114.554 266.874,113.887 261.5,113.5C 261.058,117.154 260.724,120.821 260.5,124.5C 256.466,124.495 252.466,124.162 248.5,123.5C 249.312,113.481 250.312,103.481 251.5,93.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f9e7",
    d: "M 303.5,103.5 C 314.664,107.997 325.164,113.664 335,120.5C 338.755,128.66 336.255,133.994 327.5,136.5C 330.252,147.291 327.252,149.625 318.5,143.5C 318.758,133.927 314.258,129.26 305,129.5C 304,131.5 303,133.5 302,135.5C 298.219,133.698 294.719,131.531 291.5,129C 295.648,120.539 299.648,112.039 303.5,103.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9fae7",
    d: "M 170.5,114.5 C 181.726,118.779 192.392,124.113 202.5,130.5C 200.007,132.58 197.341,134.414 194.5,136C 191.707,134.918 188.707,134.585 185.5,135C 181.759,137.732 177.759,140.066 173.5,142C 172.029,144.243 171.029,146.743 170.5,149.5C 167.749,151.293 164.916,152.959 162,154.5C 161.067,142.759 161.567,131.092 163.5,119.5C 166.077,118.057 168.41,116.39 170.5,114.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1f8887",
    d: "M 311.5,115.5 C 316.09,117.128 320.423,119.295 324.5,122C 325.517,123.049 325.684,124.216 325,125.5C 319.039,126.569 313.872,124.903 309.5,120.5C 310.456,118.925 311.123,117.258 311.5,115.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#228a89",
    d: "M 171.5,124.5 C 174.643,125.905 177.643,127.572 180.5,129.5C 177.833,131.167 175.167,132.833 172.5,134.5C 171.513,131.232 171.18,127.898 171.5,124.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7f9e6",
    d: "M 140.5,134.5 C 142.479,135.812 144.145,137.479 145.5,139.5C 143.525,142.609 141.192,145.443 138.5,148C 144.068,152.946 149.401,158.112 154.5,163.5C 152.134,166.701 149.3,169.367 146,171.5C 140.678,166.847 135.345,162.18 130,157.5C 127.333,160.167 124.667,162.833 122,165.5C 120.075,164.12 118.241,162.62 116.5,161C 124.707,152.296 132.707,143.463 140.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#148484",
    d: "M 259.5,157.5 C 256.297,158.683 253.13,160.016 250,161.5C 244.367,160.102 238.867,158.269 233.5,156C 237.192,151.834 241.525,148.667 246.5,146.5C 256.943,145.439 266.943,147.272 276.5,152C 270.661,153.375 264.994,155.208 259.5,157.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#178686",
    d: "M 229.5,156.5 C 230.738,156.81 230.738,157.31 229.5,158C 219.238,157.887 209.238,159.387 199.5,162.5C 198.537,162.03 198.537,161.363 199.5,160.5C 208.648,154.014 218.648,152.68 229.5,156.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#108383",
    d: "M 290.5,160.5 C 291.936,161.429 293.269,162.595 294.5,164C 289.806,165.862 285.806,168.695 282.5,172.5C 273.582,167.916 264.249,164.416 254.5,162C 256.233,160.811 257.9,159.644 259.5,158.5C 266.533,155.408 273.867,154.241 281.5,155C 284.528,156.844 287.528,158.678 290.5,160.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2a8e8e",
    d: "M 301.5,162.5 C 300.054,163.613 298.387,163.78 296.5,163C 295.154,161.331 293.487,160.164 291.5,159.5C 289.073,157.442 286.407,155.609 283.5,154C 285.167,153.333 286.833,153.333 288.5,154C 292.862,156.844 297.195,159.677 301.5,162.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#329292",
    d: "M 307.5,165.5 C 306.205,164.512 304.872,163.512 303.5,162.5C 300.921,159.865 297.921,157.699 294.5,156C 293.304,155.346 293.304,154.846 294.5,154.5C 301.733,156.911 308.067,160.744 313.5,166C 311.575,165.865 309.575,165.698 307.5,165.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2b8f8f",
    d: "M 198.5,160.5 C 194.571,163.382 190.237,165.716 185.5,167.5C 185.167,167.333 184.833,167.167 184.5,167C 187.202,164.005 190.202,161.505 193.5,159.5C 196.009,157.94 198.676,157.107 201.5,157C 200.29,158.039 199.29,159.206 198.5,160.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#238a8a",
    d: "M 306.5,166.5 C 311.802,170.97 316.636,175.97 321,181.5C 321.528,182.816 321.028,183.483 319.5,183.5C 318.262,184.412 316.928,184.579 315.5,184C 310.852,177.354 305.518,171.354 299.5,166C 301.929,165.297 304.262,165.463 306.5,166.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f8e6",
    d: "M 111.5,168.5 C 114.103,169.291 116.103,170.791 117.5,173C 114.38,178.739 111.38,184.573 108.5,190.5C 109.347,191.845 110.513,192.845 112,193.5C 114.93,187.966 118.096,182.633 121.5,177.5C 123.23,178.026 124.564,179.026 125.5,180.5C 123.088,185.659 120.421,190.659 117.5,195.5C 118.438,196.553 119.605,197.22 121,197.5C 125.078,191.016 128.911,184.349 132.5,177.5C 134.882,178.351 136.882,179.684 138.5,181.5C 133.509,192.151 128.009,202.484 122,212.5C 113.224,208.198 104.724,203.532 96.5,198.5C 101.513,188.473 106.513,178.473 111.5,168.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ecf5f5",
    d: "M 181.5,346.5 C 182.23,344.994 182.563,343.66 182.5,342.5C 184.5,343.167 186.5,343.833 188.5,344.5C 188.5,345.167 188.167,345.5 187.5,345.5C 186.761,345.369 186.094,345.536 185.5,346C 190.868,351.354 197.201,355.187 204.5,357.5C 205.463,357.03 205.463,356.363 204.5,355.5C 204.833,355.5 205.167,355.5 205.5,355.5C 208.475,357.824 211.808,358.657 215.5,358C 214.473,357.487 213.473,356.987 212.5,356.5C 212.5,355.833 212.833,355.5 213.5,355.5C 216.208,357.353 219.208,358.353 222.5,358.5C 223.492,358.328 224.158,358.662 224.5,359.5C 237.911,369.381 251.411,368.715 265,357.5C 265.591,356.517 265.257,355.85 264,355.5C 261.352,354.786 258.852,353.786 256.5,352.5C 256.5,352.167 256.5,351.833 256.5,351.5C 260.846,351.666 265.179,351.499 269.5,351C 272.109,347.949 273.775,344.449 274.5,340.5C 275.167,340.5 275.5,340.833 275.5,341.5C 274.851,344.945 273.518,348.111 271.5,351C 283.215,351.952 294.548,350.286 305.5,346C 312.56,339.455 318.227,331.955 322.5,323.5C 323.043,323.44 323.376,323.107 323.5,322.5C 320.232,321.513 316.898,321.18 313.5,321.5C 306.524,320.008 299.691,318.008 293,315.5C 291.373,315.625 289.873,316.125 288.5,317C 286.63,319.04 284.63,320.873 282.5,322.5C 282.167,322.5 281.833,322.5 281.5,322.5C 282.625,320.871 283.959,319.371 285.5,318C 283.402,317.322 281.402,317.489 279.5,318.5C 277.265,318.795 275.265,318.461 273.5,317.5C 274.833,317.5 276.167,317.5 277.5,317.5C 277.666,313.154 277.499,308.821 277,304.5C 275.955,303.627 275.122,302.627 274.5,301.5C 275.833,301.5 276.5,300.833 276.5,299.5C 276.833,299.5 277.167,299.5 277.5,299.5C 277.253,301.858 277.919,303.858 279.5,305.5C 278.518,308.962 278.185,312.629 278.5,316.5C 282.673,316.711 286.339,315.544 289.5,313C 288.944,312.617 288.611,312.117 288.5,311.5C 289.5,311.5 290.5,311.5 291.5,311.5C 291.962,312.88 292.962,313.547 294.5,313.5C 306.071,310.534 317.071,306.2 327.5,300.5C 328.533,295.18 328.533,289.846 327.5,284.5C 327.263,283.209 327.596,282.209 328.5,281.5C 329.229,286.13 329.563,290.797 329.5,295.5C 329.157,297.483 329.824,298.817 331.5,299.5C 330.109,302.718 330.109,304.051 331.5,303.5C 332.167,303.5 332.5,303.833 332.5,304.5C 330.878,309.414 329.545,314.414 328.5,319.5C 347.115,314.306 355.282,301.973 353,282.5C 350.63,285.039 348.13,287.372 345.5,289.5C 345.167,289.5 344.833,289.5 344.5,289.5C 347.498,286.333 350.331,283 353,279.5C 353.499,273.843 353.666,268.176 353.5,262.5C 353.5,261.833 353.833,261.5 354.5,261.5C 355.196,265.452 355.696,269.452 356,273.5C 356.333,273.167 356.667,272.833 357,272.5C 357.667,268.167 357.667,263.833 357,259.5C 356.768,258.263 356.268,257.263 355.5,256.5C 355.5,255.5 355.5,254.5 355.5,253.5C 354.969,248.041 353.802,242.708 352,237.5C 351.148,233.736 349.648,230.403 347.5,227.5C 347.167,227.5 346.833,227.5 346.5,227.5C 346.833,226.833 347.167,226.167 347.5,225.5C 348.5,224.167 349.5,224.167 350.5,225.5C 352.5,227.671 354.334,230.004 356,232.5C 356.667,230.167 356.667,227.833 356,225.5C 355.876,222.749 355.043,221.082 353.5,220.5C 353.167,220.5 352.833,220.5 352.5,220.5C 354.487,214.119 352.154,210.786 345.5,210.5C 345.5,210.167 345.5,209.833 345.5,209.5C 347.199,209.66 348.866,209.494 350.5,209C 347.063,202.568 343.229,196.401 339,190.5C 338.458,193.292 337.624,195.958 336.5,198.5C 335.833,198.5 335.5,198.167 335.5,197.5C 339.757,188.098 336.757,183.432 326.5,183.5C 325.596,184.209 325.263,185.209 325.5,186.5C 323.858,184.919 321.858,184.253 319.5,184.5C 319.5,184.167 319.5,183.833 319.5,183.5C 321.028,183.483 321.528,182.816 321,181.5C 316.636,175.97 311.802,170.97 306.5,166.5C 306.5,165.833 306.833,165.5 307.5,165.5C 309.575,165.698 311.575,165.865 313.5,166C 308.067,160.744 301.733,156.911 294.5,154.5C 293.304,154.846 293.304,155.346 294.5,156C 297.921,157.699 300.921,159.865 303.5,162.5C 302.833,162.5 302.167,162.5 301.5,162.5C 297.195,159.677 292.862,156.844 288.5,154C 286.833,153.333 285.167,153.333 283.5,154C 286.407,155.609 289.073,157.442 291.5,159.5C 290.833,159.5 290.5,159.833 290.5,160.5C 287.528,158.678 284.528,156.844 281.5,155C 273.867,154.241 266.533,155.408 259.5,158.5C 259.5,158.167 259.5,157.833 259.5,157.5C 264.994,155.208 270.661,153.375 276.5,152C 266.943,147.272 256.943,145.439 246.5,146.5C 246.611,145.883 246.944,145.383 247.5,145C 243.973,144.192 240.64,144.359 237.5,145.5C 229.046,145.928 221.046,148.095 213.5,152C 218.167,152.667 222.833,153.333 227.5,154C 228.416,154.278 229.082,154.778 229.5,155.5C 229.5,155.833 229.5,156.167 229.5,156.5C 218.648,152.68 208.648,154.014 199.5,160.5C 199.167,160.5 198.833,160.5 198.5,160.5C 199.29,159.206 200.29,158.039 201.5,157C 198.676,157.107 196.009,157.94 193.5,159.5C 192.833,159.5 192.167,159.5 191.5,159.5C 209.673,147.9 229.673,142.234 251.5,142.5C 300.304,145.493 334.804,169.159 355,213.5C 371.243,261.634 361.743,303.801 326.5,340C 286.218,372.827 242.552,378.16 195.5,356C 190.594,353.058 185.928,349.891 181.5,346.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#489e9e",
    d: "M 264.5,146.5 C 270.58,146.56 276.58,148.06 282.5,151C 280.833,151.667 279.167,151.667 277.5,151C 273.394,148.798 269.06,147.298 264.5,146.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1e8888",
    d: "M 237.5,145.5 C 239.857,145.337 242.19,145.503 244.5,146C 239.785,148.027 235.785,151.027 232.5,155C 231.552,155.483 230.552,155.649 229.5,155.5C 229.082,154.778 228.416,154.278 227.5,154C 222.833,153.333 218.167,152.667 213.5,152C 221.046,148.095 229.046,145.928 237.5,145.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2b9090",
    d: "M 310.5,168.5 C 310.56,167.957 310.893,167.624 311.5,167.5C 316.477,169.175 319.31,172.508 320,177.5C 316.964,174.296 313.797,171.296 310.5,168.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f9e6",
    d: "M 379.5,213.5 C 378.833,213.833 378.167,214.167 377.5,214.5C 375.86,211.22 374.193,207.886 372.5,204.5C 374.117,202.368 374.617,200.035 374,197.5C 371.299,192.959 368.799,188.292 366.5,183.5C 364.167,182.833 361.833,182.167 359.5,181.5C 358.333,179.167 357.167,176.833 356,174.5C 346.385,166.721 337.218,158.387 328.5,149.5C 334.783,141.715 341.616,134.382 349,127.5C 356.863,135.698 365.03,143.531 373.5,151C 371.983,152.685 370.316,154.185 368.5,155.5C 362.885,151.388 357.719,146.722 353,141.5C 351.833,142.667 350.667,143.833 349.5,145C 353.875,149.176 358.209,153.342 362.5,157.5C 361.52,158.981 360.353,160.315 359,161.5C 354.928,157.55 350.762,153.717 346.5,150C 344,149.833 342.833,151 343,153.5C 348.301,157.8 353.301,162.466 358,167.5C 358.54,169.135 358.04,170.468 356.5,171.5C 367.447,172.95 378.447,173.783 389.5,174C 392.322,177.788 393.822,181.955 394,186.5C 389.154,195.527 384.321,204.527 379.5,213.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#228b8b",
    d: "M 321.5,173.5 C 324.919,175.412 327.919,177.912 330.5,181C 328.421,181.808 326.421,181.641 324.5,180.5C 323.212,178.261 322.212,175.928 321.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a7d2c5",
    d: "M 384.5,183.5 C 381.287,183.19 378.287,183.523 375.5,184.5C 374.957,184.44 374.624,184.107 374.5,183.5C 377.98,182.194 381.313,182.194 384.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#188686",
    d: "M 326.5,183.5 C 336.757,183.432 339.757,188.098 335.5,197.5C 331.677,193.348 328.677,188.681 326.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#148584",
    d: "M 384.5,183.5 C 383.345,186.475 381.678,189.142 379.5,191.5C 377.902,189.302 376.569,186.969 375.5,184.5C 378.287,183.523 381.287,183.19 384.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#168585",
    d: "M 345.5,209.5 C 340.434,207.79 337.434,204.124 336.5,198.5C 337.624,195.958 338.458,193.292 339,190.5C 343.229,196.401 347.063,202.568 350.5,209C 348.866,209.494 347.199,209.66 345.5,209.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e8f3f3",
    d: "M 237.5,145.5 C 240.64,144.359 243.973,144.192 247.5,145C 246.944,145.383 246.611,145.883 246.5,146.5C 241.525,148.667 237.192,151.834 233.5,156C 238.867,158.269 244.367,160.102 250,161.5C 253.13,160.016 256.297,158.683 259.5,157.5C 259.5,157.833 259.5,158.167 259.5,158.5C 257.9,159.644 256.233,160.811 254.5,162C 264.249,164.416 273.582,167.916 282.5,172.5C 285.806,168.695 289.806,165.862 294.5,164C 293.269,162.595 291.936,161.429 290.5,160.5C 290.5,159.833 290.833,159.5 291.5,159.5C 293.487,160.164 295.154,161.331 296.5,163C 298.387,163.78 300.054,163.613 301.5,162.5C 302.167,162.5 302.833,162.5 303.5,162.5C 304.872,163.512 306.205,164.512 307.5,165.5C 306.833,165.5 306.5,165.833 306.5,166.5C 304.262,165.463 301.929,165.297 299.5,166C 305.518,171.354 310.852,177.354 315.5,184C 316.928,184.579 318.262,184.412 319.5,183.5C 319.5,183.833 319.5,184.167 319.5,184.5C 318.909,185.151 318.243,185.818 317.5,186.5C 321.174,191.844 324.34,197.51 327,203.5C 327.355,197.77 326.855,192.103 325.5,186.5C 325.263,185.209 325.596,184.209 326.5,183.5C 328.677,188.681 331.677,193.348 335.5,197.5C 335.5,198.167 335.833,198.5 336.5,198.5C 337.434,204.124 340.434,207.79 345.5,209.5C 345.5,209.833 345.5,210.167 345.5,210.5C 344.503,210.47 343.836,210.97 343.5,212C 345.197,215.894 347.03,219.727 349,223.5C 350.039,222.29 351.206,221.29 352.5,220.5C 352.833,220.5 353.167,220.5 353.5,220.5C 352.248,222.001 351.248,223.668 350.5,225.5C 349.5,224.167 348.5,224.167 347.5,225.5C 343.355,221.165 338.855,217.165 334,213.5C 336.387,219.11 339.554,224.443 343.5,229.5C 344.518,228.807 345.518,228.141 346.5,227.5C 346.833,227.5 347.167,227.5 347.5,227.5C 346.315,228.857 345.315,230.357 344.5,232C 348.106,239.704 351.272,247.537 354,255.5C 354.278,254.584 354.778,253.918 355.5,253.5C 355.5,254.5 355.5,255.5 355.5,256.5C 354.699,258.042 354.366,259.708 354.5,261.5C 353.833,261.5 353.5,261.833 353.5,262.5C 351.495,261.876 349.828,262.71 348.5,265C 345.691,266.741 342.691,267.908 339.5,268.5C 338.519,277.187 337.686,285.854 337,294.5C 339.4,292.585 341.9,290.919 344.5,289.5C 344.833,289.5 345.167,289.5 345.5,289.5C 342.192,292.635 338.692,295.635 335,298.5C 334.434,300.723 333.6,302.723 332.5,304.5C 332.5,303.833 332.167,303.5 331.5,303.5C 332.686,302.039 332.686,300.705 331.5,299.5C 329.824,298.817 329.157,297.483 329.5,295.5C 330.158,296.398 330.824,297.398 331.5,298.5C 333.317,296.584 334.484,294.251 335,291.5C 336.31,283.88 337.143,276.214 337.5,268.5C 335.5,268.5 333.5,268.5 331.5,268.5C 331.5,268.167 331.5,267.833 331.5,267.5C 333.833,267.5 336.167,267.5 338.5,267.5C 338.816,257.361 337.816,247.361 335.5,237.5C 334.378,238.63 333.044,239.297 331.5,239.5C 332.649,237.851 333.982,236.351 335.5,235C 334.21,228.338 332.376,221.838 330,215.5C 329.506,217.134 329.34,218.801 329.5,220.5C 328.683,218.031 328.183,215.365 328,212.5C 327.283,213.044 326.783,213.711 326.5,214.5C 322.295,220.249 317.628,225.582 312.5,230.5C 317.142,224.185 321.809,217.852 326.5,211.5C 327.016,210.242 326.35,209.242 324.5,208.5C 313.982,203.438 302.982,199.772 291.5,197.5C 288.543,195.975 287.876,196.642 289.5,199.5C 288.833,199.5 288.167,199.5 287.5,199.5C 287.033,196.703 285.367,195.369 282.5,195.5C 283.625,194.348 283.625,193.348 282.5,192.5C 281.542,191.038 280.376,189.705 279,188.5C 278.833,189.333 278.667,190.167 278.5,191C 278.684,192.376 279.351,193.209 280.5,193.5C 279.833,194.167 279.167,194.833 278.5,195.5C 278.5,197.167 278.5,198.833 278.5,200.5C 278.167,200.5 277.833,200.5 277.5,200.5C 277.5,198.5 277.5,196.5 277.5,194.5C 276.167,194.5 274.833,194.5 273.5,194.5C 274.833,193.833 276.167,193.167 277.5,192.5C 278.295,188.406 276.962,185.239 273.5,183C 269.167,179.333 264.833,175.667 260.5,172C 256.855,169.192 252.855,167.025 248.5,165.5C 238.722,170.818 229.888,177.484 222,185.5C 221.503,188.146 221.336,190.813 221.5,193.5C 234.437,191.836 247.437,191.169 260.5,191.5C 255.5,192.167 250.5,192.833 245.5,193.5C 237.49,193.644 229.49,193.977 221.5,194.5C 221.222,200.178 222.222,205.511 224.5,210.5C 223.508,210.328 222.842,210.662 222.5,211.5C 220.91,208.239 218.576,205.573 215.5,203.5C 213.049,202.589 210.715,201.756 208.5,201C 201.771,210.307 195.438,219.807 189.5,229.5C 194.348,218.972 200.348,209.139 207.5,200C 206.975,199.308 206.308,198.808 205.5,198.5C 193.551,201.26 182.218,205.594 171.5,211.5C 170.833,214.5 170.167,217.5 169.5,220.5C 169.808,218.076 169.474,215.743 168.5,213.5C 166.803,214.364 165.637,215.697 165,217.5C 163.013,226.059 161.847,234.726 161.5,243.5C 162.833,243.5 164.167,243.5 165.5,243.5C 165.5,243.833 165.5,244.167 165.5,244.5C 164.167,244.5 162.833,244.5 161.5,244.5C 160.527,242.052 160.194,239.385 160.5,236.5C 160.924,229.708 161.757,223.042 163,216.5C 156.667,221.5 151,227.167 146,233.5C 145.47,239.204 145.803,244.871 147,250.5C 147.816,249.177 148.983,248.511 150.5,248.5C 147.002,251.642 146.502,255.308 149,259.5C 150.715,265.264 152.715,270.93 155,276.5C 155.422,278.426 156.589,279.426 158.5,279.5C 158.196,280.15 157.863,280.817 157.5,281.5C 159.927,286.029 162.594,290.362 165.5,294.5C 166.528,297.098 167.528,297.098 168.5,294.5C 168.5,294.833 168.5,295.167 168.5,295.5C 170.302,297.701 171.968,300.034 173.5,302.5C 184.276,308.87 195.943,312.87 208.5,314.5C 208.897,315.525 209.563,315.692 210.5,315C 209.226,314.023 209.226,313.189 210.5,312.5C 212.05,311.559 213.716,310.893 215.5,310.5C 214.426,311.885 213.093,313.051 211.5,314C 213.973,316.437 216.973,317.604 220.5,317.5C 220.5,315.167 220.5,312.833 220.5,310.5C 220.5,309.833 220.833,309.5 221.5,309.5C 221.5,312.167 221.5,314.833 221.5,317.5C 232.78,318.829 244.113,319.496 255.5,319.5C 258.385,319.194 261.052,319.527 263.5,320.5C 249.471,320.762 235.471,320.429 221.5,319.5C 221.5,321.5 221.5,323.5 221.5,325.5C 221.5,326.167 221.167,326.5 220.5,326.5C 217.223,321.373 212.723,318.039 207,316.5C 204.119,318.524 200.953,319.857 197.5,320.5C 199.769,319.024 202.102,317.524 204.5,316C 194.11,313.426 184.11,310.092 174.5,306C 178.037,309.369 181.371,312.869 184.5,316.5C 184.167,316.5 183.833,316.5 183.5,316.5C 180.536,314.038 177.703,311.371 175,308.5C 176.662,314.211 179.328,319.544 183,324.5C 183.671,325.252 184.504,325.586 185.5,325.5C 185.5,325.833 185.5,326.167 185.5,326.5C 189.147,333.713 194.48,340.213 201.5,346C 202.793,346.49 204.127,346.657 205.5,346.5C 205.5,346.833 205.5,347.167 205.5,347.5C 204.957,347.56 204.624,347.893 204.5,348.5C 207.388,351.095 210.388,353.428 213.5,355.5C 212.833,355.5 212.5,355.833 212.5,356.5C 208.714,353.209 204.547,350.542 200,348.5C 199.167,348.667 198.333,348.833 197.5,349C 200.355,351.031 203.022,353.197 205.5,355.5C 205.167,355.5 204.833,355.5 204.5,355.5C 198.915,351.88 193.248,348.546 187.5,345.5C 188.167,345.5 188.5,345.167 188.5,344.5C 184.836,340.668 181.336,336.668 178,332.5C 178.646,336.132 180.146,339.465 182.5,342.5C 182.563,343.66 182.23,344.994 181.5,346.5C 148.069,319.613 133.236,284.613 137,241.5C 142.478,205.494 160.645,178.16 191.5,159.5C 192.167,159.5 192.833,159.5 193.5,159.5C 190.202,161.505 187.202,164.005 184.5,167C 184.833,167.167 185.167,167.333 185.5,167.5C 190.237,165.716 194.571,163.382 198.5,160.5C 198.833,160.5 199.167,160.5 199.5,160.5C 198.537,161.363 198.537,162.03 199.5,162.5C 209.238,159.387 219.238,157.887 229.5,158C 230.738,157.31 230.738,156.81 229.5,156.5C 229.5,156.167 229.5,155.833 229.5,155.5C 230.552,155.649 231.552,155.483 232.5,155C 235.785,151.027 239.785,148.027 244.5,146C 242.19,145.503 239.857,145.337 237.5,145.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#91c8c8",
    d: "M 260.5,191.5 C 261.492,191.328 262.158,191.662 262.5,192.5C 261.833,192.5 261.5,192.833 261.5,193.5C 256.167,193.5 250.833,193.5 245.5,193.5C 250.5,192.833 255.5,192.167 260.5,191.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#108383",
    d: "M 174.5,191.5 C 183.925,191.273 192.925,193.106 201.5,197C 190.942,200.684 180.609,204.851 170.5,209.5C 170.335,206.15 170.502,202.817 171,199.5C 172.454,196.929 173.62,194.262 174.5,191.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#158686",
    d: "M 305.5,190.5 C 308.14,190.954 310.473,192.121 312.5,194C 316.5,198 320.5,202 324.5,206C 314.985,202.418 305.318,199.085 295.5,196C 299.056,194.392 302.389,192.559 305.5,190.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#228b8b",
    d: "M 282.5,192.5 C 282.158,193.338 281.492,193.672 280.5,193.5C 279.351,193.209 278.684,192.376 278.5,191C 278.667,190.167 278.833,189.333 279,188.5C 280.376,189.705 281.542,191.038 282.5,192.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#329393",
    d: "M 219.5,187.5 C 221.92,192.82 220.254,194.987 214.5,194C 215.999,191.672 217.666,189.505 219.5,187.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#288c8c",
    d: "M 313.5,186.5 C 316.091,187.254 317.924,188.921 319,191.5C 321.608,195.707 323.608,200.04 325,204.5C 319.887,199.387 314.721,194.221 309.5,189C 311.066,188.392 312.4,187.558 313.5,186.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1f8989",
    d: "M 319.5,184.5 C 321.858,184.253 323.858,184.919 325.5,186.5C 326.855,192.103 327.355,197.77 327,203.5C 324.34,197.51 321.174,191.844 317.5,186.5C 318.243,185.818 318.909,185.151 319.5,184.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bbdddd",
    d: "M 224.5,169.5 C 223.673,173.807 223.007,178.14 222.5,182.5C 222.158,183.338 221.492,183.672 220.5,183.5C 221.137,180.544 221.637,177.544 222,174.5C 222.374,172.509 223.207,170.842 224.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#168686",
    d: "M 174.5,175.5 C 175.239,175.369 175.906,175.536 176.5,176C 174.092,180.652 172.092,185.485 170.5,190.5C 165.412,192.079 160.746,194.412 156.5,197.5C 156.167,197.167 155.833,196.833 155.5,196.5C 160.803,188.532 167.137,181.532 174.5,175.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#128484",
    d: "M 280.5,178.5 C 281.479,177.235 282.479,175.901 283.5,174.5C 291.347,178.588 298.681,183.421 305.5,189C 299.928,193.63 293.594,195.63 286.5,195C 284.707,192.205 282.54,189.705 280,187.5C 279.505,184.469 279.671,181.469 280.5,178.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#258c8c",
    d: "M 186.5,168.5 C 187.239,168.369 187.906,168.536 188.5,169C 182.889,175.278 178.056,182.112 174,189.5C 174.609,180.268 178.776,173.268 186.5,168.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0e8383",
    d: "M 294.5,165.5 C 295.552,165.351 296.552,165.517 297.5,166C 303.908,171.738 309.575,178.071 314.5,185C 312.086,186.885 309.419,187.552 306.5,187C 299.505,181.834 292.172,177.167 284.5,173C 287.192,169.452 290.525,166.952 294.5,165.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#078181",
    d: "M 277.5,192.5 C 272.5,192.5 267.5,192.5 262.5,192.5C 262.158,191.662 261.492,191.328 260.5,191.5C 247.437,191.169 234.437,191.836 221.5,193.5C 221.336,190.813 221.503,188.146 222,185.5C 229.888,177.484 238.722,170.818 248.5,165.5C 252.855,167.025 256.855,169.192 260.5,172C 264.833,175.667 269.167,179.333 273.5,183C 276.962,185.239 278.295,188.406 277.5,192.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#138585",
    d: "M 280.5,178.5 C 279.208,180.255 278.208,182.255 277.5,184.5C 269.378,176.944 260.712,170.11 251.5,164C 262.255,165.197 272.255,168.697 281.5,174.5C 280.754,175.736 280.421,177.07 280.5,178.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#108484",
    d: "M 222.5,182.5 C 223.007,178.14 223.673,173.807 224.5,169.5C 226.266,166.812 227.933,163.979 229.5,161C 234.19,160.668 238.857,161.002 243.5,162C 244.672,162.419 245.672,163.085 246.5,164C 237.768,169.234 229.768,175.401 222.5,182.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#098282",
    d: "M 224.5,169.5 C 223.207,170.842 222.374,172.509 222,174.5C 221.637,177.544 221.137,180.544 220.5,183.5C 217.738,187.439 214.738,191.272 211.5,195C 209.722,195.704 207.888,196.204 206,196.5C 196.24,192.448 186.073,190.114 175.5,189.5C 180.524,179.977 187.191,171.811 195.5,165C 205.888,161.101 216.554,159.934 227.5,161.5C 225.924,163.979 224.924,166.646 224.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#128484",
    d: "M 168.5,192.5 C 169.586,192.62 170.253,193.287 170.5,194.5C 168.434,201.198 166.267,207.864 164,214.5C 156.978,218.679 150.978,224.012 146,230.5C 144.061,212.021 151.561,199.355 168.5,192.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#058181",
    d: "M 245.5,193.5 C 250.833,193.5 256.167,193.5 261.5,193.5C 265.519,193.646 269.519,193.979 273.5,194.5C 274.833,194.5 276.167,194.5 277.5,194.5C 277.5,196.5 277.5,198.5 277.5,200.5C 278.028,201.847 278.195,203.181 278,204.5C 272.038,207.976 266.538,211.976 261.5,216.5C 259.596,216.738 258.262,217.738 257.5,219.5C 255.973,219.427 254.973,220.094 254.5,221.5C 252.596,221.738 251.262,222.738 250.5,224.5C 248.596,224.738 247.262,225.738 246.5,227.5C 243.937,227.731 242.27,229.065 241.5,231.5C 238.397,233.423 235.397,235.59 232.5,238C 231.668,238.688 231.002,238.521 230.5,237.5C 227.193,228.901 224.526,220.234 222.5,211.5C 222.842,210.662 223.508,210.328 224.5,210.5C 222.222,205.511 221.222,200.178 221.5,194.5C 229.49,193.977 237.49,193.644 245.5,193.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b9dbdb",
    d: "M 261.5,193.5 C 261.5,192.833 261.833,192.5 262.5,192.5C 267.5,192.5 272.5,192.5 277.5,192.5C 276.167,193.167 274.833,193.833 273.5,194.5C 269.519,193.979 265.519,193.646 261.5,193.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#95caca",
    d: "M 282.5,192.5 C 283.625,193.348 283.625,194.348 282.5,195.5C 281.167,195.5 279.833,195.5 278.5,195.5C 279.167,194.833 279.833,194.167 280.5,193.5C 281.492,193.672 282.158,193.338 282.5,192.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#258b8b",
    d: "M 332.5,204.5 C 331.094,204.973 330.427,205.973 330.5,207.5C 329.417,201.948 328.584,196.281 328,190.5C 329.667,193.167 331.333,195.833 333,198.5C 333.49,200.545 333.323,202.545 332.5,204.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#168686",
    d: "M 215.5,203.5 C 214.167,202.067 212.667,200.733 211,199.5C 210.333,198.833 210.333,198.167 211,197.5C 213.951,195.924 217.117,195.257 220.5,195.5C 220.82,198.898 220.487,202.232 219.5,205.5C 218.378,204.37 217.044,203.703 215.5,203.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1b8888",
    d: "M 278.5,195.5 C 279.833,195.5 281.167,195.5 282.5,195.5C 285.367,195.369 287.033,196.703 287.5,199.5C 284.658,200.172 282.158,201.506 280,203.5C 279.768,202.263 279.268,201.263 278.5,200.5C 278.5,198.833 278.5,197.167 278.5,195.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0c8383",
    d: "M 291.5,197.5 C 302.982,199.772 313.982,203.438 324.5,208.5C 323.319,210.067 321.653,210.901 319.5,211C 321.81,211.497 324.143,211.663 326.5,211.5C 321.809,217.852 317.142,224.185 312.5,230.5C 310.926,230.063 309.759,229.063 309,227.5C 307.213,223.423 305.046,219.59 302.5,216C 307.838,214.666 313.172,213.333 318.5,212C 312.75,212.191 307.083,212.858 301.5,214C 297.833,209 294.167,204 290.5,199C 291.056,198.617 291.389,198.117 291.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0b8282",
    d: "M 189.5,229.5 C 185.852,235.462 182.685,241.796 180,248.5C 178.915,247.707 177.748,247.04 176.5,246.5C 172.688,235.149 171.021,223.482 171.5,211.5C 182.218,205.594 193.551,201.26 205.5,198.5C 206.308,198.808 206.975,199.308 207.5,200C 200.348,209.139 194.348,218.972 189.5,229.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1e8888",
    d: "M 335.5,208.5 C 331.814,208.87 330.814,207.537 332.5,204.5C 333.79,203.942 334.623,202.942 335,201.5C 336.5,203.667 338,205.833 339.5,208C 338.207,208.49 336.873,208.657 335.5,208.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#098282",
    d: "M 268.5,225.5 C 263.466,226.398 258.799,228.065 254.5,230.5C 252.063,230.756 249.729,231.423 247.5,232.5C 244.14,231.209 243.806,229.543 246.5,227.5C 248.404,227.262 249.738,226.262 250.5,224.5C 252.404,224.262 253.738,223.262 254.5,221.5C 256.027,221.573 257.027,220.906 257.5,219.5C 259.404,219.262 260.738,218.262 261.5,216.5C 266.782,213.855 271.782,210.688 276.5,207C 277.449,206.383 278.282,206.549 279,207.5C 279.562,211.52 280.729,215.353 282.5,219C 277.885,221.261 273.218,223.428 268.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9ccdcd",
    d: "M 332.5,204.5 C 330.814,207.537 331.814,208.87 335.5,208.5C 337.167,209.167 338.833,209.833 340.5,210.5C 337.833,210.5 335.167,210.5 332.5,210.5C 331.449,209.778 330.782,208.778 330.5,207.5C 330.427,205.973 331.094,204.973 332.5,204.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#94c9c9",
    d: "M 324.5,208.5 C 326.35,209.242 327.016,210.242 326.5,211.5C 324.143,211.663 321.81,211.497 319.5,211C 321.653,210.901 323.319,210.067 324.5,208.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#168787",
    d: "M 332.5,210.5 C 335.167,210.5 337.833,210.5 340.5,210.5C 342.274,213.363 343.441,216.363 344,219.5C 340.267,216.255 336.434,213.255 332.5,210.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1b8787",
    d: "M 345.5,210.5 C 352.154,210.786 354.487,214.119 352.5,220.5C 351.206,221.29 350.039,222.29 349,223.5C 347.03,219.727 345.197,215.894 343.5,212C 343.836,210.97 344.503,210.47 345.5,210.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7f9e6",
    d: "M 378.5,219.5 C 378.365,217.446 379.032,215.779 380.5,214.5C 389.469,212.981 398.469,211.647 407.5,210.5C 408.247,217.562 409.414,224.562 411,231.5C 414.64,247.471 408.473,255.304 392.5,255C 389.063,253.895 386.563,251.728 385,248.5C 382.001,239.006 379.835,229.339 378.5,219.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4da3a3",
    d: "M 168.5,205.5 C 170.013,208.157 169.513,210.49 167,212.5C 167.157,210.169 167.657,207.836 168.5,205.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7f9e6",
    d: "M 94.5,212.5 C 97.1873,212.336 99.854,212.503 102.5,213C 103.893,214.171 104.727,215.671 105,217.5C 107.553,212.374 111.386,211.207 116.5,214C 117.126,214.75 117.626,215.584 118,216.5C 118.667,221.167 118.667,225.833 118,230.5C 116.18,238.752 115.013,247.085 114.5,255.5C 104.501,254.167 94.5012,252.834 84.5,251.5C 85.9,241.101 87.7333,230.768 90,220.5C 90.7384,217.352 92.2384,214.685 94.5,212.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bddddd",
    d: "M 224.5,210.5 C 228.1,212.43 231.1,215.097 233.5,218.5C 229.9,216.57 226.9,213.903 224.5,210.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#118484",
    d: "M 169.5,220.5 C 170.058,228.129 171.392,235.629 173.5,243C 173.472,244.07 173.139,244.903 172.5,245.5C 170.401,244.388 168.067,243.721 165.5,243.5C 164.167,243.5 162.833,243.5 161.5,243.5C 161.847,234.726 163.013,226.059 165,217.5C 165.637,215.697 166.803,214.364 168.5,213.5C 169.474,215.743 169.808,218.076 169.5,220.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#128484",
    d: "M 326.5,214.5 C 327.632,220.698 327.465,227.031 326,233.5C 325.118,236.789 324.452,240.123 324,243.5C 322.482,244.163 321.315,245.163 320.5,246.5C 319.504,246.586 318.671,246.252 318,245.5C 316.726,242.609 315.226,239.942 313.5,237.5C 313.123,235.742 312.456,234.075 311.5,232.5C 311.863,231.817 312.196,231.15 312.5,230.5C 317.628,225.582 322.295,220.249 326.5,214.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8dc4ba",
    d: "M 379.5,213.5 C 379.5,214.167 379.833,214.5 380.5,214.5C 379.032,215.779 378.365,217.446 378.5,219.5C 377.549,218.081 377.216,216.415 377.5,214.5C 378.167,214.167 378.833,213.833 379.5,213.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bbdddc",
    d: "M 222.5,211.5 C 224.526,220.234 227.193,228.901 230.5,237.5C 231.002,238.521 231.668,238.688 232.5,238C 235.397,235.59 238.397,233.423 241.5,231.5C 242.27,229.065 243.937,227.731 246.5,227.5C 243.806,229.543 244.14,231.209 247.5,232.5C 249.729,231.423 252.063,230.756 254.5,230.5C 252.402,231.935 250.069,233.102 247.5,234C 248.823,234.816 249.489,235.983 249.5,237.5C 248.185,236.524 246.852,235.524 245.5,234.5C 240.825,236.505 236.158,238.505 231.5,240.5C 233.076,242.979 234.076,245.646 234.5,248.5C 233.024,246.231 231.524,243.898 230,241.5C 228.649,243.019 227.149,244.352 225.5,245.5C 225.167,244.833 224.833,244.167 224.5,243.5C 223.232,244.428 221.899,244.595 220.5,244C 223.787,242.696 226.787,241.03 229.5,239C 225.832,230.162 223.499,220.995 222.5,211.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#098282",
    d: "M 288.5,230.5 C 288.008,228.181 287.008,226.181 285.5,224.5C 285.5,223.167 285.5,221.833 285.5,220.5C 290.772,218.792 296.105,217.625 301.5,217C 304.586,221.759 307.253,226.759 309.5,232C 306.365,236.302 302.699,240.136 298.5,243.5C 294.916,239.317 291.582,234.984 288.5,230.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1e8989",
    d: "M 347.5,225.5 C 347.167,226.167 346.833,226.833 346.5,227.5C 345.518,228.141 344.518,228.807 343.5,229.5C 339.554,224.443 336.387,219.11 334,213.5C 338.855,217.165 343.355,221.165 347.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d0e8e7",
    d: "M 261.5,216.5 C 260.738,218.262 259.404,219.262 257.5,219.5C 258.262,217.738 259.596,216.738 261.5,216.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0b8282",
    d: "M 160.5,236.5 C 159.835,238.698 159.168,241.031 158.5,243.5C 155.127,244.179 152.46,245.846 150.5,248.5C 148.983,248.511 147.816,249.177 147,250.5C 145.803,244.871 145.47,239.204 146,233.5C 151,227.167 156.667,221.5 163,216.5C 161.757,223.042 160.924,229.708 160.5,236.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1b8787",
    d: "M 331.5,239.5 C 329.83,239.751 328.33,240.418 327,241.5C 327.406,234.488 328.239,227.488 329.5,220.5C 329.34,218.801 329.506,217.134 330,215.5C 332.376,221.838 334.21,228.338 335.5,235C 333.982,236.351 332.649,237.851 331.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b6dada",
    d: "M 233.5,218.5 C 237.045,220.857 239.545,223.857 241,227.5C 237.888,224.899 235.388,221.899 233.5,218.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c2e0e0",
    d: "M 257.5,219.5 C 257.027,220.906 256.027,221.573 254.5,221.5C 254.973,220.094 255.973,219.427 257.5,219.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#208a8a",
    d: "M 332.5,216.5 C 335.974,220.762 338.974,225.429 341.5,230.5C 340.579,232.756 338.912,233.756 336.5,233.5C 335.949,227.632 334.616,221.965 332.5,216.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#278c8c",
    d: "M 350.5,225.5 C 351.248,223.668 352.248,222.001 353.5,220.5C 355.043,221.082 355.876,222.749 356,225.5C 356.667,227.833 356.667,230.167 356,232.5C 354.334,230.004 352.5,227.671 350.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#058181",
    d: "M 285.5,224.5 C 285.461,227.089 286.461,229.089 288.5,230.5C 290.769,235.536 293.435,240.369 296.5,245C 292.343,249.991 288.009,254.824 283.5,259.5C 280.236,261.094 277.569,263.427 275.5,266.5C 273.264,267.389 271.264,268.722 269.5,270.5C 268.817,270.137 268.15,269.804 267.5,269.5C 265.54,262.914 262.54,256.914 258.5,251.5C 258.25,249.326 257.25,247.659 255.5,246.5C 255.573,244.973 254.906,243.973 253.5,243.5C 253.573,241.973 252.906,240.973 251.5,240.5C 251.573,238.973 250.906,237.973 249.5,237.5C 249.489,235.983 248.823,234.816 247.5,234C 250.069,233.102 252.402,231.935 254.5,230.5C 259.534,229.602 264.201,227.935 268.5,225.5C 273.243,224.481 277.909,223.147 282.5,221.5C 283.735,222.34 284.735,223.34 285.5,224.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b4dad9",
    d: "M 254.5,221.5 C 253.738,223.262 252.404,224.262 250.5,224.5C 251.262,222.738 252.596,221.738 254.5,221.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#138483",
    d: "M 393.5,224.5 C 396.5,224.5 399.5,224.5 402.5,224.5C 403.368,228.808 403.534,233.141 403,237.5C 400.774,241.861 397.274,243.361 392.5,242C 388.75,237.176 387.084,231.676 387.5,225.5C 389.735,225.795 391.735,225.461 393.5,224.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#228987",
    d: "M 96.5,225.5 C 97.8333,225.5 99.1667,225.5 100.5,225.5C 100.249,230.507 99.9157,235.507 99.5,240.5C 97.8561,240.714 96.3561,240.38 95,239.5C 94.5196,234.733 95.0196,230.067 96.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6cb1b1",
    d: "M 143.5,220.5 C 144.147,221.274 144.48,222.274 144.5,223.5C 143.918,227.155 143.418,230.822 143,234.5C 142.436,229.806 142.603,225.14 143.5,220.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#badcdc",
    d: "M 250.5,224.5 C 249.738,226.262 248.404,227.262 246.5,227.5C 247.262,225.738 248.596,224.738 250.5,224.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#248a88",
    d: "M 106.5,226.5 C 107.833,226.5 109.167,226.5 110.5,226.5C 110.782,232.148 109.782,237.481 107.5,242.5C 106.264,241.754 104.93,241.421 103.5,241.5C 104.178,236.429 105.178,231.429 106.5,226.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d8ebeb",
    d: "M 285.5,224.5 C 287.008,226.181 288.008,228.181 288.5,230.5C 286.461,229.089 285.461,227.089 285.5,224.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9ecece",
    d: "M 268.5,225.5 C 264.201,227.935 259.534,229.602 254.5,230.5C 258.799,228.065 263.466,226.398 268.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1e8888",
    d: "M 347.5,227.5 C 349.648,230.403 351.148,233.736 352,237.5C 353.802,242.708 354.969,248.041 355.5,253.5C 354.778,253.918 354.278,254.584 354,255.5C 351.272,247.537 348.106,239.704 344.5,232C 345.315,230.357 346.315,228.857 347.5,227.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#178787",
    d: "M 241.5,231.5 C 243.103,231.312 244.437,231.812 245.5,233C 243.35,234.59 241.017,235.257 238.5,235C 239.71,233.961 240.71,232.794 241.5,231.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#118484",
    d: "M 341.5,232.5 C 343.474,234.428 344.974,236.761 346,239.5C 348.466,245.732 350.633,252.066 352.5,258.5C 349.557,263.47 345.223,266.136 339.5,266.5C 339.936,256.573 339.269,246.74 337.5,237C 338.604,235.285 339.938,233.785 341.5,232.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0d8282",
    d: "M 249.5,237.5 C 249.427,239.027 250.094,240.027 251.5,240.5C 251.427,242.027 252.094,243.027 253.5,243.5C 253.427,245.027 254.094,246.027 255.5,246.5C 255.75,248.674 256.75,250.341 258.5,251.5C 260.992,257.818 263.992,263.818 267.5,269.5C 267.5,270.5 267.5,271.5 267.5,272.5C 262.843,273.664 258.343,275.331 254,277.5C 252.697,277.022 251.531,276.355 250.5,275.5C 250.573,273.973 249.906,272.973 248.5,272.5C 247.66,270.147 246.326,268.147 244.5,266.5C 244.573,264.973 243.906,263.973 242.5,263.5C 241.59,260.008 239.924,257.008 237.5,254.5C 235.992,252.819 234.992,250.819 234.5,248.5C 234.076,245.646 233.076,242.979 231.5,240.5C 236.158,238.505 240.825,236.505 245.5,234.5C 246.852,235.524 248.185,236.524 249.5,237.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0a8282",
    d: "M 313.5,237.5 C 314.202,240.578 315.202,243.578 316.5,246.5C 315.037,248.393 313.37,250.059 311.5,251.5C 309.83,251.751 308.33,252.418 307,253.5C 303.888,250.899 301.388,247.899 299.5,244.5C 302.964,241.538 306.297,238.371 309.5,235C 311.082,235.193 312.416,236.026 313.5,237.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#238c8c",
    d: "M 351.5,230.5 C 356.549,234.56 358.049,239.56 356,245.5C 354.595,240.452 353.095,235.452 351.5,230.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cae4e4",
    d: "M 291.5,197.5 C 291.389,198.117 291.056,198.617 290.5,199C 294.167,204 297.833,209 301.5,214C 307.083,212.858 312.75,212.191 318.5,212C 313.172,213.333 307.838,214.666 302.5,216C 305.046,219.59 307.213,223.423 309,227.5C 309.759,229.063 310.926,230.063 312.5,230.5C 312.196,231.15 311.863,231.817 311.5,232.5C 312.456,234.075 313.123,235.742 313.5,237.5C 312.416,236.026 311.082,235.193 309.5,235C 306.297,238.371 302.964,241.538 299.5,244.5C 298.167,244.5 297.5,245.167 297.5,246.5C 293.441,251.562 288.774,255.895 283.5,259.5C 288.009,254.824 292.343,249.991 296.5,245C 293.435,240.369 290.769,235.536 288.5,230.5C 291.582,234.984 294.916,239.317 298.5,243.5C 302.699,240.136 306.365,236.302 309.5,232C 307.253,226.759 304.586,221.759 301.5,217C 296.105,217.625 290.772,218.792 285.5,220.5C 285.5,221.833 285.5,223.167 285.5,224.5C 284.735,223.34 283.735,222.34 282.5,221.5C 277.909,223.147 273.243,224.481 268.5,225.5C 273.218,223.428 277.885,221.261 282.5,219C 280.729,215.353 279.562,211.52 279,207.5C 278.282,206.549 277.449,206.383 276.5,207C 271.782,210.688 266.782,213.855 261.5,216.5C 266.538,211.976 272.038,207.976 278,204.5C 278.195,203.181 278.028,201.847 277.5,200.5C 277.833,200.5 278.167,200.5 278.5,200.5C 279.268,201.263 279.768,202.263 280,203.5C 282.158,201.506 284.658,200.172 287.5,199.5C 285.519,201.303 283.352,202.97 281,204.5C 280.872,209.63 281.705,214.63 283.5,219.5C 289.064,218.445 294.397,216.778 299.5,214.5C 296.115,209.464 292.782,204.464 289.5,199.5C 287.876,196.642 288.543,195.975 291.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0b8282",
    d: "M 287.5,199.5 C 288.167,199.5 288.833,199.5 289.5,199.5C 292.782,204.464 296.115,209.464 299.5,214.5C 294.397,216.778 289.064,218.445 283.5,219.5C 281.705,214.63 280.872,209.63 281,204.5C 283.352,202.97 285.519,201.303 287.5,199.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c9e4e4",
    d: "M 249.5,237.5 C 250.906,237.973 251.573,238.973 251.5,240.5C 250.094,240.027 249.427,239.027 249.5,237.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#108383",
    d: "M 331.5,267.5 C 329.657,266.717 327.657,266.05 325.5,265.5C 321.603,258.525 321.603,251.525 325.5,244.5C 327.571,242.815 329.571,241.148 331.5,239.5C 333.044,239.297 334.378,238.63 335.5,237.5C 337.816,247.361 338.816,257.361 338.5,267.5C 336.167,267.5 333.833,267.5 331.5,267.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3f9797",
    d: "M 142.5,238.5 C 144.322,242.214 145.322,246.381 145.5,251C 145.375,252.627 144.875,254.127 144,255.5C 142.072,249.974 141.572,244.308 142.5,238.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#088181",
    d: "M 215.5,203.5 C 218.576,205.573 220.91,208.239 222.5,211.5C 223.499,220.995 225.832,230.162 229.5,239C 226.787,241.03 223.787,242.696 220.5,244C 221.899,244.595 223.232,244.428 224.5,243.5C 224.833,244.167 225.167,244.833 225.5,245.5C 227.149,244.352 228.649,243.019 230,241.5C 231.524,243.898 233.024,246.231 234.5,248.5C 234.992,250.819 235.992,252.819 237.5,254.5C 238.41,257.992 240.076,260.992 242.5,263.5C 242.427,265.027 243.094,266.027 244.5,266.5C 244.845,269.198 246.178,271.198 248.5,272.5C 248.427,274.027 249.094,275.027 250.5,275.5C 251.171,276.847 251.171,278.014 250.5,279C 245.944,280.566 241.61,282.399 237.5,284.5C 230.655,286.392 223.822,288.392 217,290.5C 213.317,283.788 209.151,277.455 204.5,271.5C 203.634,269.856 203.134,268.189 203,266.5C 207.37,262.298 211.537,257.964 215.5,253.5C 210.578,257.08 205.911,261.08 201.5,265.5C 199.183,263.684 197.016,261.684 195,259.5C 194.383,258.551 194.549,257.718 195.5,257C 194.551,256.383 193.718,256.549 193,257.5C 191.871,255.859 190.371,254.859 188.5,254.5C 186.425,252.281 184.091,250.281 181.5,248.5C 184.461,242.25 187.128,235.916 189.5,229.5C 195.438,219.807 201.771,210.307 208.5,201C 210.715,201.756 213.049,202.589 215.5,203.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c3e1e1",
    d: "M 251.5,240.5 C 252.906,240.973 253.573,241.973 253.5,243.5C 252.094,243.027 251.427,242.027 251.5,240.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#87c3c3",
    d: "M 165.5,244.5 C 165.5,244.167 165.5,243.833 165.5,243.5C 168.067,243.721 170.401,244.388 172.5,245.5C 172.5,245.833 172.5,246.167 172.5,246.5C 170.228,245.681 167.894,245.015 165.5,244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c1e0e0",
    d: "M 253.5,243.5 C 254.906,243.973 255.573,244.973 255.5,246.5C 254.094,246.027 253.427,245.027 253.5,243.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0d8382",
    d: "M 158.5,279.5 C 156.589,279.426 155.422,278.426 155,276.5C 152.715,270.93 150.715,265.264 149,259.5C 146.502,255.308 147.002,251.642 150.5,248.5C 153.257,246.914 156.257,245.914 159.5,245.5C 159.171,254.58 159.838,263.58 161.5,272.5C 161.333,273.833 161.167,275.167 161,276.5C 159.955,277.373 159.122,278.373 158.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#108383",
    d: "M 161.5,244.5 C 162.833,244.5 164.167,244.5 165.5,244.5C 167.894,245.015 170.228,245.681 172.5,246.5C 173.376,246.369 174.043,246.702 174.5,247.5C 178.204,255.767 177.204,263.434 171.5,270.5C 169.973,270.427 168.973,271.094 168.5,272.5C 166.973,272.427 165.973,273.094 165.5,274.5C 164.25,274.423 163.417,273.756 163,272.5C 161.684,263.218 161.184,253.884 161.5,244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cfe7e7",
    d: "M 255.5,246.5 C 257.25,247.659 258.25,249.326 258.5,251.5C 256.75,250.341 255.75,248.674 255.5,246.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#138484",
    d: "M 297.5,246.5 C 300.297,248.795 302.964,251.295 305.5,254C 297.948,257.608 290.614,261.441 283.5,265.5C 283.158,266.338 282.492,266.672 281.5,266.5C 279.323,266.586 277.323,267.253 275.5,268.5C 274.537,268.03 274.537,267.363 275.5,266.5C 278.764,264.906 281.431,262.573 283.5,259.5C 288.774,255.895 293.441,251.562 297.5,246.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3b9696",
    d: "M 358.5,243.5 C 360.646,246.912 361.646,250.745 361.5,255C 361.577,258.339 360.91,261.505 359.5,264.5C 357.507,257.557 357.174,250.557 358.5,243.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c0dfdf",
    d: "M 215.5,253.5 C 217.528,250.281 220.195,248.114 223.5,247C 221.229,249.782 218.563,251.949 215.5,253.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1a8888",
    d: "M 139.5,246.5 C 141.821,253.319 141.988,260.319 140,267.5C 138.256,260.519 138.089,253.519 139.5,246.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cee6e6",
    d: "M 215.5,245.5 C 216.552,245.351 217.552,245.517 218.5,246C 213.727,248.898 208.727,250.898 203.5,252C 207.722,250.059 211.722,247.892 215.5,245.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d9eceb",
    d: "M 329.5,220.5 C 328.239,227.488 327.406,234.488 327,241.5C 328.33,240.418 329.83,239.751 331.5,239.5C 329.571,241.148 327.571,242.815 325.5,244.5C 321.603,251.525 321.603,258.525 325.5,265.5C 327.657,266.05 329.657,266.717 331.5,267.5C 331.5,267.833 331.5,268.167 331.5,268.5C 329.401,267.769 327.401,267.769 325.5,268.5C 326.822,272.77 327.822,277.103 328.5,281.5C 327.596,282.209 327.263,283.209 327.5,284.5C 326.552,278.931 325.386,273.265 324,267.5C 322.732,264.938 320.898,264.272 318.5,265.5C 312.008,282.509 303.008,297.843 291.5,311.5C 301.967,296.812 310.633,280.978 317.5,264C 313.957,260.792 310.123,257.959 306,255.5C 298.644,259.263 291.144,262.597 283.5,265.5C 290.614,261.441 297.948,257.608 305.5,254C 302.964,251.295 300.297,248.795 297.5,246.5C 297.5,245.167 298.167,244.5 299.5,244.5C 301.388,247.899 303.888,250.899 307,253.5C 308.33,252.418 309.83,251.751 311.5,251.5C 313.37,250.059 315.037,248.393 316.5,246.5C 315.202,243.578 314.202,240.578 313.5,237.5C 315.226,239.942 316.726,242.609 318,245.5C 318.671,246.252 319.504,246.586 320.5,246.5C 321.315,245.163 322.482,244.163 324,243.5C 324.452,240.123 325.118,236.789 326,233.5C 327.465,227.031 327.632,220.698 326.5,214.5C 326.783,213.711 327.283,213.044 328,212.5C 328.183,215.365 328.683,218.031 329.5,220.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#178686",
    d: "M 311.5,251.5 C 313.746,250.545 316.079,249.878 318.5,249.5C 321.657,262.194 318.491,264.194 309,255.5C 309.193,253.918 310.026,252.584 311.5,251.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#288d8d",
    d: "M 320.5,246.5 C 322.847,248.03 323.014,250.03 321,252.5C 319.2,250.635 319.034,248.635 320.5,246.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#078181",
    d: "M 291.5,311.5 C 290.5,311.5 289.5,311.5 288.5,311.5C 288.027,310.094 287.027,309.427 285.5,309.5C 285.027,308.094 284.027,307.427 282.5,307.5C 282.027,306.094 281.027,305.427 279.5,305.5C 277.919,303.858 277.253,301.858 277.5,299.5C 275.913,290.905 273.413,282.572 270,274.5C 272.018,282.907 274.185,291.241 276.5,299.5C 276.5,300.833 275.833,301.5 274.5,301.5C 269.167,295.5 263.5,289.833 257.5,284.5C 257.392,282.486 258.058,280.82 259.5,279.5C 266.337,274.33 273.671,269.997 281.5,266.5C 282.492,266.672 283.158,266.338 283.5,265.5C 291.144,262.597 298.644,259.263 306,255.5C 310.123,257.959 313.957,260.792 317.5,264C 310.633,280.978 301.967,296.812 291.5,311.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c6e2e2",
    d: "M 258.5,251.5 C 262.54,256.914 265.54,262.914 267.5,269.5C 263.992,263.818 260.992,257.818 258.5,251.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#248b8b",
    d: "M 145.5,255.5 C 148.121,264.183 151.455,272.683 155.5,281C 154.315,282.353 152.981,283.52 151.5,284.5C 148.147,276.607 145.48,268.44 143.5,260C 144.044,258.415 144.711,256.915 145.5,255.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#278d8d",
    d: "M 355.5,256.5 C 356.268,257.263 356.768,258.263 357,259.5C 357.667,263.833 357.667,268.167 357,272.5C 356.667,272.833 356.333,273.167 356,273.5C 355.696,269.452 355.196,265.452 354.5,261.5C 354.366,259.708 354.699,258.042 355.5,256.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b5dada",
    d: "M 237.5,254.5 C 239.924,257.008 241.59,260.008 242.5,263.5C 240.076,260.992 238.41,257.992 237.5,254.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#228b8b",
    d: "M 320.5,259.5 C 322.476,260.427 322.809,261.76 321.5,263.5C 320.571,262.311 320.238,260.978 320.5,259.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a8d3d3",
    d: "M 283.5,259.5 C 281.431,262.573 278.764,264.906 275.5,266.5C 277.569,263.427 280.236,261.094 283.5,259.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dbeded",
    d: "M 171.5,211.5 C 171.021,223.482 172.688,235.149 176.5,246.5C 177.748,247.04 178.915,247.707 180,248.5C 182.685,241.796 185.852,235.462 189.5,229.5C 187.128,235.916 184.461,242.25 181.5,248.5C 184.091,250.281 186.425,252.281 188.5,254.5C 190.371,254.859 191.871,255.859 193,257.5C 193.718,256.549 194.551,256.383 195.5,257C 194.549,257.718 194.383,258.551 195,259.5C 197.016,261.684 199.183,263.684 201.5,265.5C 205.911,261.08 210.578,257.08 215.5,253.5C 211.537,257.964 207.37,262.298 203,266.5C 203.134,268.189 203.634,269.856 204.5,271.5C 203.206,270.71 202.039,269.71 201,268.5C 196.984,272.348 193.151,276.348 189.5,280.5C 192.124,285.585 195.124,290.418 198.5,295C 208.313,294.034 208.646,294.868 199.5,297.5C 202.932,302.707 206.598,307.707 210.5,312.5C 209.226,313.189 209.226,314.023 210.5,315C 209.563,315.692 208.897,315.525 208.5,314.5C 208.649,313.448 208.483,312.448 208,311.5C 204.324,306.802 200.658,302.135 197,297.5C 189.24,299.565 181.407,301.232 173.5,302.5C 171.968,300.034 170.302,297.701 168.5,295.5C 169.936,287.581 171.603,279.581 173.5,271.5C 173.043,270.702 172.376,270.369 171.5,270.5C 177.204,263.434 178.204,255.767 174.5,247.5C 174.043,246.702 173.376,246.369 172.5,246.5C 172.5,246.167 172.5,245.833 172.5,245.5C 173.139,244.903 173.472,244.07 173.5,243C 171.392,235.629 170.058,228.129 169.5,220.5C 170.167,217.5 170.833,214.5 171.5,211.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#278d8d",
    d: "M 179.5,265.5 C 178.504,265.414 177.671,265.748 177,266.5C 176.516,264.087 176.85,261.754 178,259.5C 180.078,261.262 180.578,263.262 179.5,265.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#128484",
    d: "M 190.5,259.5 C 194.512,260.67 197.512,263.17 199.5,267C 196.382,271.121 192.882,274.954 189,278.5C 186.306,274.446 184.139,270.112 182.5,265.5C 184.902,263.091 187.569,261.091 190.5,259.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1a8787",
    d: "M 188.5,254.5 C 189.29,255.794 190.29,256.961 191.5,258C 188.088,259.455 184.921,261.288 182,263.5C 179.099,259.205 178.932,254.872 181.5,250.5C 183.725,252.11 186.059,253.443 188.5,254.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#359494",
    d: "M 176.5,248.5 C 179.838,249.193 180.338,250.86 178,253.5C 177.392,251.846 176.892,250.179 176.5,248.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#138484",
    d: "M 353.5,262.5 C 353.666,268.176 353.499,273.843 353,279.5C 350.331,283 347.498,286.333 344.5,289.5C 341.9,290.919 339.4,292.585 337,294.5C 337.686,285.854 338.519,277.187 339.5,268.5C 342.691,267.908 345.691,266.741 348.5,265C 349.828,262.71 351.495,261.876 353.5,262.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c0dfdf",
    d: "M 242.5,263.5 C 243.906,263.973 244.573,264.973 244.5,266.5C 243.094,266.027 242.427,265.027 242.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0e8383",
    d: "M 327.5,284.5 C 328.533,289.846 328.533,295.18 327.5,300.5C 317.071,306.2 306.071,310.534 294.5,313.5C 292.962,313.547 291.962,312.88 291.5,311.5C 303.008,297.843 312.008,282.509 318.5,265.5C 320.898,264.272 322.732,264.938 324,267.5C 325.386,273.265 326.552,278.931 327.5,284.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#329191",
    d: "M 142.5,265.5 C 144.928,270.54 146.428,275.873 147,281.5C 142.967,276.959 141.467,271.626 142.5,265.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#158585",
    d: "M 179.5,265.5 C 180.376,265.369 181.043,265.702 181.5,266.5C 183.226,270.953 185.226,275.286 187.5,279.5C 186.048,280.94 185.048,282.606 184.5,284.5C 181.757,286.239 179.757,288.573 178.5,291.5C 176.413,292.585 175.08,294.251 174.5,296.5C 173.542,296.953 172.708,297.619 172,298.5C 171.357,288.683 172.357,279.016 175,269.5C 176.667,268.267 178.167,266.933 179.5,265.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#108484",
    d: "M 331.5,268.5 C 333.5,268.5 335.5,268.5 337.5,268.5C 337.143,276.214 336.31,283.88 335,291.5C 334.484,294.251 333.317,296.584 331.5,298.5C 330.824,297.398 330.158,296.398 329.5,295.5C 329.563,290.797 329.229,286.13 328.5,281.5C 327.822,277.103 326.822,272.77 325.5,268.5C 327.401,267.769 329.401,267.769 331.5,268.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c6e2e2",
    d: "M 244.5,266.5 C 246.326,268.147 247.66,270.147 248.5,272.5C 246.178,271.198 244.845,269.198 244.5,266.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1e8e8",
    d: "M 171.5,270.5 C 171.027,271.906 170.027,272.573 168.5,272.5C 168.973,271.094 169.973,270.427 171.5,270.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#178686",
    d: "M 171.5,270.5 C 172.376,270.369 173.043,270.702 173.5,271.5C 171.603,279.581 169.936,287.581 168.5,295.5C 168.5,295.167 168.5,294.833 168.5,294.5C 165.857,287.971 164.857,281.304 165.5,274.5C 167.027,274.573 168.027,273.906 168.5,272.5C 170.027,272.573 171.027,271.906 171.5,270.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c3e1e1",
    d: "M 168.5,272.5 C 168.027,273.906 167.027,274.573 165.5,274.5C 165.973,273.094 166.973,272.427 168.5,272.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cee6e6",
    d: "M 248.5,272.5 C 249.906,272.973 250.573,273.973 250.5,275.5C 249.094,275.027 248.427,274.027 248.5,272.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1e8e8",
    d: "M 160.5,236.5 C 160.194,239.385 160.527,242.052 161.5,244.5C 161.184,253.884 161.684,263.218 163,272.5C 163.417,273.756 164.25,274.423 165.5,274.5C 164.857,281.304 165.857,287.971 168.5,294.5C 167.528,297.098 166.528,297.098 165.5,294.5C 166.097,294.265 166.43,293.765 166.5,293C 164.922,287.856 163.422,282.689 162,277.5C 161.184,278.823 160.017,279.489 158.5,279.5C 159.122,278.373 159.955,277.373 161,276.5C 161.167,275.167 161.333,273.833 161.5,272.5C 159.838,263.58 159.171,254.58 159.5,245.5C 156.257,245.914 153.257,246.914 150.5,248.5C 152.46,245.846 155.127,244.179 158.5,243.5C 159.168,241.031 159.835,238.698 160.5,236.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b5d9d9",
    d: "M 277.5,299.5 C 277.167,299.5 276.833,299.5 276.5,299.5C 274.185,291.241 272.018,282.907 270,274.5C 273.413,282.572 275.913,290.905 277.5,299.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cfe7e7",
    d: "M 275.5,266.5 C 274.537,267.363 274.537,268.03 275.5,268.5C 277.323,267.253 279.323,266.586 281.5,266.5C 273.671,269.997 266.337,274.33 259.5,279.5C 258.058,280.82 257.392,282.486 257.5,284.5C 256.609,283.89 255.609,283.557 254.5,283.5C 254.441,281.278 253.275,280.278 251,280.5C 246.584,282.139 242.084,283.472 237.5,284.5C 241.61,282.399 245.944,280.566 250.5,279C 251.171,278.014 251.171,276.847 250.5,275.5C 251.531,276.355 252.697,277.022 254,277.5C 258.343,275.331 262.843,273.664 267.5,272.5C 267.5,271.5 267.5,270.5 267.5,269.5C 268.15,269.804 268.817,270.137 269.5,270.5C 271.264,268.722 273.264,267.389 275.5,266.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#268d8d",
    d: "M 259.5,279.5 C 257.983,279.511 256.816,280.177 256,281.5C 255.308,280.975 254.808,280.308 254.5,279.5C 256.899,277.461 259.566,276.295 262.5,276C 261.29,277.039 260.29,278.206 259.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2d8f8e",
    d: "M 165.5,294.5 C 162.594,290.362 159.927,286.029 157.5,281.5C 157.863,280.817 158.196,280.15 158.5,279.5C 160.017,279.489 161.184,278.823 162,277.5C 163.422,282.689 164.922,287.856 166.5,293C 166.43,293.765 166.097,294.265 165.5,294.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5babab",
    d: "M 356.5,275.5 C 357.673,280.827 357.173,286.16 355,291.5C 355.107,286.162 355.607,280.828 356.5,275.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0b8282",
    d: "M 254.5,283.5 C 252.596,283.738 251.262,284.738 250.5,286.5C 248.596,286.738 247.262,287.738 246.5,289.5C 244.973,289.427 243.973,290.094 243.5,291.5C 241.596,291.738 240.262,292.738 239.5,294.5C 237.973,294.427 236.973,295.094 236.5,296.5C 231.635,298.763 227.302,301.763 223.5,305.5C 222.504,305.414 221.671,305.748 221,306.5C 219.67,301.516 218.504,296.516 217.5,291.5C 224.531,289.936 231.198,287.602 237.5,284.5C 242.084,283.472 246.584,282.139 251,280.5C 253.275,280.278 254.441,281.278 254.5,283.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#238b8b",
    d: "M 142.5,279.5 C 144.846,281.674 146.846,284.174 148.5,287C 147.464,288.901 146.298,290.735 145,292.5C 143.686,288.246 142.853,283.913 142.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0a8282",
    d: "M 174.5,296.5 C 176.587,295.415 177.92,293.749 178.5,291.5C 181.243,289.761 183.243,287.427 184.5,284.5C 185.794,283.71 186.961,282.71 188,281.5C 191.085,286 193.918,290.667 196.5,295.5C 189.047,298.62 181.38,299.954 173.5,299.5C 174.127,298.583 174.461,297.583 174.5,296.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#128484",
    d: "M 332.5,304.5 C 333.6,302.723 334.434,300.723 335,298.5C 338.692,295.635 342.192,292.635 345.5,289.5C 348.13,287.372 350.63,285.039 353,282.5C 355.282,301.973 347.115,314.306 328.5,319.5C 329.545,314.414 330.878,309.414 332.5,304.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#208a8a",
    d: "M 155.5,282.5 C 158.915,287.764 162.582,292.931 166.5,298C 161.061,295.271 156.061,291.604 151.5,287C 153.041,285.629 154.375,284.129 155.5,282.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c3e1e1",
    d: "M 254.5,283.5 C 253.738,285.262 252.404,286.262 250.5,286.5C 251.262,284.738 252.596,283.738 254.5,283.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#088181",
    d: "M 254.5,283.5 C 255.609,283.557 256.609,283.89 257.5,284.5C 262.167,291.167 267.833,296.833 274.5,301.5C 275.122,302.627 275.955,303.627 277,304.5C 277.499,308.821 277.666,313.154 277.5,317.5C 276.167,317.5 274.833,317.5 273.5,317.5C 267.331,317.918 261.331,318.585 255.5,319.5C 244.113,319.496 232.78,318.829 221.5,317.5C 221.5,314.833 221.5,312.167 221.5,309.5C 221.733,307.938 222.4,306.605 223.5,305.5C 228.365,303.237 232.698,300.237 236.5,296.5C 238.027,296.573 239.027,295.906 239.5,294.5C 241.404,294.262 242.738,293.262 243.5,291.5C 245.027,291.573 246.027,290.906 246.5,289.5C 248.404,289.262 249.738,288.262 250.5,286.5C 252.404,286.262 253.738,285.262 254.5,283.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c0e0e0",
    d: "M 250.5,286.5 C 249.738,288.262 248.404,289.262 246.5,289.5C 247.262,287.738 248.596,286.738 250.5,286.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c5e2e2",
    d: "M 257.5,284.5 C 263.5,289.833 269.167,295.5 274.5,301.5C 267.833,296.833 262.167,291.167 257.5,284.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bfdede",
    d: "M 184.5,284.5 C 183.243,287.427 181.243,289.761 178.5,291.5C 179.757,288.573 181.757,286.239 184.5,284.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#198686",
    d: "M 149.5,288.5 C 152.288,292.312 154.621,296.479 156.5,301C 146.103,301.619 143.769,297.453 149.5,288.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c6e3e3",
    d: "M 246.5,289.5 C 246.027,290.906 245.027,291.573 243.5,291.5C 243.973,290.094 244.973,289.427 246.5,289.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c4e1e1",
    d: "M 204.5,271.5 C 209.151,277.455 213.317,283.788 217,290.5C 223.822,288.392 230.655,286.392 237.5,284.5C 231.198,287.602 224.531,289.936 217.5,291.5C 218.504,296.516 219.67,301.516 221,306.5C 221.671,305.748 222.504,305.414 223.5,305.5C 222.4,306.605 221.733,307.938 221.5,309.5C 220.833,309.5 220.5,309.833 220.5,310.5C 218.901,309.438 217.234,309.438 215.5,310.5C 217.062,309.215 218.396,307.715 219.5,306C 218.515,301.208 216.848,296.708 214.5,292.5C 212.265,293.752 209.931,294.252 207.5,294C 210,293.115 212.333,291.948 214.5,290.5C 211.396,283.955 208.063,277.622 204.5,271.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bfdfdf",
    d: "M 243.5,291.5 C 242.738,293.262 241.404,294.262 239.5,294.5C 240.262,292.738 241.596,291.738 243.5,291.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cce6e5",
    d: "M 178.5,291.5 C 177.92,293.749 176.587,295.415 174.5,296.5C 175.08,294.251 176.413,292.585 178.5,291.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0d8383",
    d: "M 204.5,271.5 C 208.063,277.622 211.396,283.955 214.5,290.5C 212.333,291.948 210,293.115 207.5,294C 209.931,294.252 212.265,293.752 214.5,292.5C 216.848,296.708 218.515,301.208 219.5,306C 218.396,307.715 217.062,309.215 215.5,310.5C 213.716,310.893 212.05,311.559 210.5,312.5C 206.598,307.707 202.932,302.707 199.5,297.5C 208.646,294.868 208.313,294.034 198.5,295C 195.124,290.418 192.124,285.585 189.5,280.5C 193.151,276.348 196.984,272.348 201,268.5C 202.039,269.71 203.206,270.71 204.5,271.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#278c8c",
    d: "M 166.5,300.5 C 164.052,301.473 161.385,301.806 158.5,301.5C 156.726,298.637 155.559,295.637 155,292.5C 158.437,295.777 162.271,298.443 166.5,300.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c0dfdf",
    d: "M 239.5,294.5 C 239.027,295.906 238.027,296.573 236.5,296.5C 236.973,295.094 237.973,294.427 239.5,294.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#148484",
    d: "M 208.5,314.5 C 195.943,312.87 184.276,308.87 173.5,302.5C 181.407,301.232 189.24,299.565 197,297.5C 200.658,302.135 204.324,306.802 208,311.5C 208.483,312.448 208.649,313.448 208.5,314.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9dcece",
    d: "M 166.5,300.5 C 167.309,301.469 168.309,302.302 169.5,303C 169.272,303.399 168.938,303.565 168.5,303.5C 167.5,303.5 166.5,303.5 165.5,303.5C 163.167,302.833 160.833,302.167 158.5,301.5C 161.385,301.806 164.052,301.473 166.5,300.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#298f8e",
    d: "M 331.5,299.5 C 332.686,300.705 332.686,302.039 331.5,303.5C 330.109,304.051 330.109,302.718 331.5,299.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#138484",
    d: "M 326.5,302.5 C 329.424,308.455 328.758,314.288 324.5,320C 314.696,321.04 305.363,319.373 296.5,315C 307.209,312.271 317.209,308.105 326.5,302.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#128484",
    d: "M 149.5,302.5 C 152.522,302.981 155.522,303.647 158.5,304.5C 159.414,306.664 160.581,308.664 162,310.5C 162.401,314.316 161.734,317.983 160,321.5C 155.461,315.756 151.961,309.422 149.5,302.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#198787",
    d: "M 165.5,303.5 C 166.5,303.5 167.5,303.5 168.5,303.5C 167.223,305.95 165.723,308.283 164,310.5C 162.581,308.664 161.414,306.664 160.5,304.5C 162.045,303.548 163.712,303.215 165.5,303.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c4e1e1",
    d: "M 236.5,296.5 C 232.698,300.237 228.365,303.237 223.5,305.5C 227.302,301.763 231.635,298.763 236.5,296.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cfe7e7",
    d: "M 279.5,305.5 C 281.027,305.427 282.027,306.094 282.5,307.5C 280.973,307.573 279.973,306.906 279.5,305.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#218a8a",
    d: "M 168.5,305.5 C 169.947,310.651 170.78,315.985 171,321.5C 169.034,318.399 167.2,315.232 165.5,312C 166.391,309.721 167.391,307.554 168.5,305.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1e8888",
    d: "M 197.5,320.5 C 197.158,321.338 196.492,321.672 195.5,321.5C 194.417,321.539 193.417,321.873 192.5,322.5C 189.804,320.491 187.137,318.491 184.5,316.5C 181.371,312.869 178.037,309.369 174.5,306C 184.11,310.092 194.11,313.426 204.5,316C 202.102,317.524 199.769,319.024 197.5,320.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#238a8a",
    d: "M 279.5,305.5 C 279.973,306.906 280.973,307.573 282.5,307.5C 282.973,308.906 283.973,309.573 285.5,309.5C 285.973,310.906 286.973,311.573 288.5,311.5C 288.611,312.117 288.944,312.617 289.5,313C 286.339,315.544 282.673,316.711 278.5,316.5C 278.185,312.629 278.518,308.962 279.5,305.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c9e4e4",
    d: "M 282.5,307.5 C 284.027,307.427 285.027,308.094 285.5,309.5C 283.973,309.573 282.973,308.906 282.5,307.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#148585",
    d: "M 220.5,310.5 C 220.5,312.833 220.5,315.167 220.5,317.5C 216.973,317.604 213.973,316.437 211.5,314C 213.093,313.051 214.426,311.885 215.5,310.5C 217.234,309.438 218.901,309.438 220.5,310.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bfdfdf",
    d: "M 285.5,309.5 C 287.027,309.427 288.027,310.094 288.5,311.5C 286.973,311.573 285.973,310.906 285.5,309.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#208a89",
    d: "M 171.5,307.5 C 174.335,313.696 177.668,319.696 181.5,325.5C 179.548,327.533 177.382,327.866 175,326.5C 173.044,320.31 171.878,313.977 171.5,307.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#238b8b",
    d: "M 183.5,316.5 C 185.173,318.839 187.173,320.839 189.5,322.5C 188.099,323.521 186.765,324.521 185.5,325.5C 184.504,325.586 183.671,325.252 183,324.5C 179.328,319.544 176.662,314.211 175,308.5C 177.703,311.371 180.536,314.038 183.5,316.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#068181",
    d: "M 313.5,321.5 C 316.5,322.167 319.5,322.833 322.5,323.5C 318.227,331.955 312.56,339.455 305.5,346C 294.548,350.286 283.215,351.952 271.5,351C 273.518,348.111 274.851,344.945 275.5,341.5C 277.544,337.174 278.711,332.507 279,327.5C 280.802,326.211 281.969,324.544 282.5,322.5C 284.63,320.873 286.63,319.04 288.5,317C 289.873,316.125 291.373,315.625 293,315.5C 299.691,318.008 306.524,320.008 313.5,321.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#178686",
    d: "M 163.5,314.5 C 167.055,318.584 170.389,322.918 173.5,327.5C 169.457,329.228 165.957,328.562 163,325.5C 162.421,321.797 162.588,318.131 163.5,314.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0e8383",
    d: "M 220.5,326.5 C 219.525,329.067 218.858,331.733 218.5,334.5C 217.662,334.842 217.328,335.508 217.5,336.5C 216.85,336.804 216.183,337.137 215.5,337.5C 208.075,334.041 201.242,329.708 195,324.5C 194.53,323.423 194.697,322.423 195.5,321.5C 196.492,321.672 197.158,321.338 197.5,320.5C 200.953,319.857 204.119,318.524 207,316.5C 212.723,318.039 217.223,321.373 220.5,326.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1b8787",
    d: "M 344.5,312.5 C 340.75,322.311 334.083,330.311 324.5,336.5C 324.167,336.167 323.833,335.833 323.5,335.5C 325.497,331.343 326.997,327.01 328,322.5C 332.15,320.671 336.316,318.837 340.5,317C 342.041,315.629 343.375,314.129 344.5,312.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#178686",
    d: "M 281.5,322.5 C 280.883,322.611 280.383,322.944 280,323.5C 279.506,321.866 279.34,320.199 279.5,318.5C 281.402,317.489 283.402,317.322 285.5,318C 283.959,319.371 282.625,320.871 281.5,322.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8dc5c5",
    d: "M 313.5,321.5 C 316.898,321.18 320.232,321.513 323.5,322.5C 323.376,323.107 323.043,323.44 322.5,323.5C 319.5,322.833 316.5,322.167 313.5,321.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#108484",
    d: "M 205.5,346.5 C 204.127,346.657 202.793,346.49 201.5,346C 194.48,340.213 189.147,333.713 185.5,326.5C 187.707,325.261 190.041,324.761 192.5,325C 199.16,329.999 206.16,334.499 213.5,338.5C 214.521,339.002 214.688,339.668 214,340.5C 211.329,342.902 208.495,344.902 205.5,346.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1b8787",
    d: "M 181.5,327.5 C 182.496,327.414 183.329,327.748 184,328.5C 188.481,334.979 193.648,340.812 199.5,346C 197.5,346.667 195.5,346.667 193.5,346C 187.985,340.652 182.652,335.152 177.5,329.5C 178.949,328.828 180.282,328.161 181.5,327.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#258c8c",
    d: "M 325.5,321.5 C 325.333,328.715 322.666,335.215 317.5,341C 315.598,342.301 313.598,342.968 311.5,343C 317.308,336.544 321.975,329.378 325.5,321.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#198787",
    d: "M 168.5,331.5 C 170.288,330.378 172.288,330.211 174.5,331C 175.817,333.438 176.651,335.938 177,338.5C 174.002,336.332 171.169,333.999 168.5,331.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#148484",
    d: "M 274.5,340.5 C 273.775,344.449 272.109,347.949 269.5,351C 265.179,351.499 260.846,351.666 256.5,351.5C 255.026,350.416 254.193,349.082 254,347.5C 261.875,342.559 269.208,336.893 276,330.5C 276.463,333.98 275.963,337.314 274.5,340.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2a8f8f",
    d: "M 188.5,344.5 C 186.5,343.833 184.5,343.167 182.5,342.5C 180.146,339.465 178.646,336.132 178,332.5C 181.336,336.668 184.836,340.668 188.5,344.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0f8383",
    d: "M 222.5,358.5 C 219.208,358.353 216.208,357.353 213.5,355.5C 210.388,353.428 207.388,351.095 204.5,348.5C 204.624,347.893 204.957,347.56 205.5,347.5C 209.811,345.679 213.811,343.345 217.5,340.5C 226.197,344.622 235.197,347.955 244.5,350.5C 237.58,354.582 230.247,357.248 222.5,358.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#319191",
    d: "M 187.5,345.5 C 193.248,348.546 198.915,351.88 204.5,355.5C 205.463,356.363 205.463,357.03 204.5,357.5C 197.201,355.187 190.868,351.354 185.5,346C 186.094,345.536 186.761,345.369 187.5,345.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dceded",
    d: "M 183.5,316.5 C 183.833,316.5 184.167,316.5 184.5,316.5C 187.137,318.491 189.804,320.491 192.5,322.5C 193.417,321.873 194.417,321.539 195.5,321.5C 194.697,322.423 194.53,323.423 195,324.5C 201.242,329.708 208.075,334.041 215.5,337.5C 216.183,337.137 216.85,336.804 217.5,336.5C 217.414,337.496 217.748,338.329 218.5,339C 228.112,344.152 238.112,347.319 248.5,348.5C 238.666,342.824 229.832,335.824 222,327.5C 220.979,329.97 219.812,332.304 218.5,334.5C 218.858,331.733 219.525,329.067 220.5,326.5C 221.167,326.5 221.5,326.167 221.5,325.5C 230.339,334.169 240.172,341.502 251,347.5C 260.226,341.613 268.893,334.947 277,327.5C 277.497,324.854 277.664,322.187 277.5,319.5C 272.819,319.669 268.152,320.002 263.5,320.5C 261.052,319.527 258.385,319.194 255.5,319.5C 261.331,318.585 267.331,317.918 273.5,317.5C 275.265,318.461 277.265,318.795 279.5,318.5C 279.34,320.199 279.506,321.866 280,323.5C 280.383,322.944 280.883,322.611 281.5,322.5C 281.833,322.5 282.167,322.5 282.5,322.5C 281.969,324.544 280.802,326.211 279,327.5C 278.711,332.507 277.544,337.174 275.5,341.5C 275.5,340.833 275.167,340.5 274.5,340.5C 275.963,337.314 276.463,333.98 276,330.5C 269.208,336.893 261.875,342.559 254,347.5C 254.193,349.082 255.026,350.416 256.5,351.5C 256.5,351.833 256.5,352.167 256.5,352.5C 253.201,351.624 249.868,351.457 246.5,352C 239.526,355.602 232.193,358.102 224.5,359.5C 224.158,358.662 223.492,358.328 222.5,358.5C 230.247,357.248 237.58,354.582 244.5,350.5C 235.197,347.955 226.197,344.622 217.5,340.5C 213.811,343.345 209.811,345.679 205.5,347.5C 205.5,347.167 205.5,346.833 205.5,346.5C 208.495,344.902 211.329,342.902 214,340.5C 214.688,339.668 214.521,339.002 213.5,338.5C 206.16,334.499 199.16,329.999 192.5,325C 190.041,324.761 187.707,325.261 185.5,326.5C 185.5,326.167 185.5,325.833 185.5,325.5C 186.765,324.521 188.099,323.521 189.5,322.5C 187.173,320.839 185.173,318.839 183.5,316.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1c8787",
    d: "M 217.5,336.5 C 217.328,335.508 217.662,334.842 218.5,334.5C 219.812,332.304 220.979,329.97 222,327.5C 229.832,335.824 238.666,342.824 248.5,348.5C 238.112,347.319 228.112,344.152 218.5,339C 217.748,338.329 217.414,337.496 217.5,336.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0a8282",
    d: "M 263.5,320.5 C 268.152,320.002 272.819,319.669 277.5,319.5C 277.664,322.187 277.497,324.854 277,327.5C 268.893,334.947 260.226,341.613 251,347.5C 240.172,341.502 230.339,334.169 221.5,325.5C 221.5,323.5 221.5,321.5 221.5,319.5C 235.471,320.429 249.471,320.762 263.5,320.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2c9090",
    d: "M 215.5,319.5 C 216.919,318.549 218.585,318.216 220.5,318.5C 220.66,320.199 220.494,321.866 220,323.5C 218.629,321.959 217.129,320.625 215.5,319.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2b8e8e",
    d: "M 313.5,344.5 C 314.239,344.369 314.906,344.536 315.5,345C 310.542,350.474 304.542,353.807 297.5,355C 302.489,350.82 307.822,347.32 313.5,344.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#208a8a",
    d: "M 212.5,356.5 C 213.473,356.987 214.473,357.487 215.5,358C 211.808,358.657 208.475,357.824 205.5,355.5C 203.022,353.197 200.355,351.031 197.5,349C 198.333,348.833 199.167,348.667 200,348.5C 204.547,350.542 208.714,353.209 212.5,356.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#118483",
    d: "M 256.5,352.5 C 258.852,353.786 261.352,354.786 264,355.5C 265.257,355.85 265.591,356.517 265,357.5C 251.411,368.715 237.911,369.381 224.5,359.5C 232.193,358.102 239.526,355.602 246.5,352C 249.868,351.457 253.201,351.624 256.5,352.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#218989",
    d: "M 295.5,350.5 C 296.873,350.343 298.207,350.51 299.5,351C 297.191,353.487 294.524,355.487 291.5,357C 283.652,358.031 275.985,357.364 268.5,355C 277.616,353.971 286.616,352.471 295.5,350.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1d8787",
    d: "M 267.5,356.5 C 273.299,358.597 279.299,359.764 285.5,360C 275.23,365.643 264.23,367.976 252.5,367C 258.617,364.954 263.617,361.454 267.5,356.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#399696",
    d: "M 216.5,361.5 C 217.946,360.387 219.613,360.22 221.5,361C 224.417,362.528 227.417,363.861 230.5,365C 225.651,364.753 220.985,363.587 216.5,361.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetathreadTeal);
export default __webpack_public_path__ + "static/media/betathread-teal.b13cc1fe44a3b09225cfbb4891de4592.svg";
export { ForwardRef as ReactComponent };